const initialState = window.__STATE__.captcha || {}

export default function reducer(state = initialState, action) {
  return state
}



// WEBPACK FOOTER //
// ./client/Modules/Captcha/reducer.js